<nb-card
  [nbSpinner]="processing"
  nbSpinnerMessage="Loading..."
  [size]="step === 'topup' ? '' : unsettled > 0 ? 'large' : 'small'"
  class="tw-w-[95vw] lg:tw-w-auto content tw-flex tw-flex-col"
  [class.content--topup]="step === 'topup'"
>
  <nb-card-header class="d-flex align-items-center justify-content-between">
    <span class="header-text">{{ step === 'topup' ? 'Top up wallet' : 'Event database' }}</span>
    <button nbButton class="float-right" ghost (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <div class="settle">
      <!-- Settling info -->
      <div class="d-flex flex-column gap-1" *ngIf="!exporting && step === 'settle'">
        <ngx-export-section>
          <ngx-settle-line [title]="registrantMode ? 'Selected entries' : 'Entries'" [count]="selected" [bold]="true"></ngx-settle-line>
          <ngx-settle-line title="Settled" [count]="settled"></ngx-settle-line>
          <ngx-settle-line title="Unsettled" [count]="unsettled"></ngx-settle-line>
        </ngx-export-section>
        <ngx-export-section *ngIf="!processing && unsettled > 0">
          <div class="settling-title">I want to settle</div>
          <ngx-settle-table [settledTotal]="settledTotal" [settledForms]="settledForms" [records]="records" [registrantMode]="registrantMode" [plan]="currentPlan">
          </ngx-settle-table>
        </ngx-export-section>
        <div *ngIf="!processing && unsettled > 0 && totalPrice > 0 && insufficientBalance" class="tw-flex tw-min-h-11 tw-items-center">
          <div class="tw-w-full tw-rounded-lg tw-border tw-border-amber-200 tw-bg-amber-50 tw-px-2 tw-py-3">
            <div class="tw-flex tw-items-center tw-gap-2">
              <svg class="tw-shrink-0" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                  d="M2.99882 19H16.9921C19.295 19 20.7426 16.5 19.6021 14.5435L12.5835 2.5C11.443 0.5 8.54787 0.5 7.40735 2.5L0.388796 14.5435C-0.729787 16.5217 0.695858 19 2.99882 19ZM10.0174 16.3261C9.40326 16.3261 8.8988 15.8261 8.8988 15.2174C8.8988 14.6087 9.40326 14.1087 10.0174 14.1087C10.6315 14.1087 11.136 14.6087 11.114 15.2391C11.136 15.8261 10.6096 16.3261 10.0174 16.3261ZM9.73225 6.32609C10.2586 6.19565 10.807 6.45652 11.0263 6.95652C11.0921 7.13043 11.136 7.30435 11.136 7.5C11.114 8.04348 11.0702 8.6087 11.0263 9.15217C10.9824 10 10.9166 10.8696 10.8728 11.7174C10.8508 12 10.8508 12.2391 10.8508 12.5217C10.8289 12.9783 10.478 13.3261 10.0174 13.3261C9.55679 13.3261 9.20586 13 9.18393 12.5435C9.11813 11.2174 9.0304 9.8913 8.9646 8.56522C8.94266 8.21739 8.92073 7.86957 8.8988 7.5C8.87686 6.95652 9.20586 6.47826 9.73225 6.32609Z"
                  fill="#E3A008"
                />
              </svg>
              <p class="tw-m-0 tw-text-sm tw-leading-5 tw-text-gray-700">
                <span class="tw-font-medium">Insufficient balance. </span>
                <span class="tw-font-normal">Please add </span>
                <span class="tw-font-semibold">{{ balanceShortfallUsd | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}</span>
                <span class="tw-font-normal"> to settle and export.</span>
              </p>
            </div>
          </div>
        </div>
        <div class="upgrade-save text-center" *ngIf="currentPlan === 'Basic' && savings > 0">
          Save {{ savings | currency : 'USD' : 'symbol-narrow' : '1.2-2' }} with a PRO plan - <a (click)="openBilling()">Upgrade now!</a>
        </div>
      </div>
      @if (step === 'topup') {
      <app-billing-wallet-top-up-modal
        [embedded]="true"
        [active]="true"
        [initialCustomAmount]="suggestedTopUpAmount()"
        [paymentMethods]="paymentMethods"
        (topUpSuccess)="onWalletTopUpSuccess($event)"
        (cancelRequested)="backFromTopUp()"
      ></app-billing-wallet-top-up-modal>
      }
      <div class="d-flex justify-content-center align-items-center flex-column" style="width: 100%; height: 100%" *ngIf="exporting">
        <h4 class="text-success text-center" *ngIf="exportStatus.status === 'running'">You currently have a running export!</h4>

        <br />
        <h6 class="text-center" *ngIf="exportStatus.status === 'running'">
          <strong class="text-success">{{ exportStatus.progress.toFixed(2) }}% </strong> <span class="text-success"> Completed</span>
        </h6>
        <br />
        <!-- <h6 class="text-center">An email with the export download link {{ exportStatus.status === 'finished' ? ' was ' : ' will be ' }} sent to your email address!</h6>
        <br />
        <br />
        <div class="text-hint">Feel free to close this popup{{ exportStatus.status === 'running' ? ', your export will continue running in the background' : '.' }}</div> -->
        <h6 class="text-center">Your export is now under processing and it will be sent to your registered email address.</h6>
        <br />
        <br />
        <div class="text-hint">Please note that it might take 10 minutes to 1 hour until you receive the export email, depending on the size of your data.</div>
        <br />
        <button nbButton status="basic" (click)="close()">Close</button>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer *ngIf="!exporting && step === 'settle' && !processing" class="settle-card-footer">
    <div class="actions">
      <button
        nbButton
        class="!tw-rounded-lg"
        [ngClass]="{ left: totalPrice > 0 }"
        status="primary"
        size="large"
        [disabled]="!canSettleProceed || loadingPaymentMethods"
        *ngIf="registrantMode && totalPrice > 0"
        (click)="onSettleClick()"
      >
        Settle
      </button>
      <button
        nbButton
        class="!tw-rounded-lg"
        [ngClass]="{ right: totalPrice > 0 }"
        status="primary"
        size="large"
        [disabled]="!canPayExportProceed || loadingPaymentMethods"
        *ngIf="registrantMode"
        (click)="onPayExportClick()"
      >
        @if (insufficientBalance && totalPrice > 0) {
        {{ loadingPaymentMethods ? 'Loading…' : 'Top up' }}
        } @else {
        {{ totalPrice > 0 ? 'Settle &' : '' }} Export }
      </button>
      <button nbButton class="!tw-rounded-lg" status="primary" size="large" [disabled]="!canPayExportProceed || loadingPaymentMethods" *ngIf="!registrantMode" (click)="onPayExportClick()">
        @if (insufficientBalance && totalPrice > 0) {
        {{ loadingPaymentMethods ? 'Loading…' : 'Top up' }}
        } @else {
        {{ totalPrice > 0 ? 'Pay &' : '' }} Export }
      </button>
    </div>
  </nb-card-footer>
</nb-card>
